import { DatePipe } from '@angular/common';
import { computed, inject, Injectable, signal } from '@angular/core';
import type { ChartEvent, ChartType } from 'chart.js';
import { chartDefaults } from '../components/line-values/defaults';
import { LineValuesKpi } from '../types';

@Injectable()
export class ChartService {
  public readonly lineChartType: ChartType = 'line';

  public readonly lineChartPlugins = chartDefaults.plugins();

  public readonly lineChartOptions = chartDefaults.options();

  public readonly data$ = signal<LineValuesKpi>(null!);

  private readonly datePipe = inject(DatePipe);

  public readonly lineChartData$ = computed(() => {
    const yAxisLabel = this.data$()?.yAxisLabel?.trim();
    const lineChartData = chartDefaults.data();

    this.lineChartOptions.scales.y['title'] = {
      display: Boolean(yAxisLabel),
      text: yAxisLabel,
    };

    lineChartData.labels = [];
    lineChartData.datasets[0].data = [];
    lineChartData.datasets[0].label = 'Ticket count';

    this.data$()?.value.forEach((item) => {
      lineChartData.labels.push(this.formatLabel(item.label));
      lineChartData.datasets[0].data.push(item.value);
    });

    return lineChartData;
  });

  public chartClicked(event: { event?: ChartEvent; active?: object[] }): void {
    if (!event.active?.length || event.active?.[0]?.['index'] === undefined) {
    }
  }

  private formatLabel(label: string): string {
    try {
      return this.datePipe.transform(label, 'MMM yyyy') || label;
    } catch {
      return label;
    }
  }
}
